<script lang="ts" setup>
const props = defineProps({
  listIds: {
    default: () => [],
    type: Array as PropType<number[]>,
  },
  max: {
    default: Number.POSITIVE_INFINITY,
    type: Number,
  },
  size: {
    default: 'sm',
    type: String as PropType<UBadgeSize | UButtonSize>,
  },
  wrap: {
    default: true,
    type: Boolean,
  },
})

const listsStore = useListsStore()
const localePath = useLocalePath()

const badges = computed((): UBadge[] => {
  return props.listIds.map((listId) => {
    const list = listsStore.lists.find(list => list.id === listId)

    return {
      color: 'gray',
      label: truncate(list?.name, 25),
      to: localePath({
        name: 'companies-lists-listId',
        params: { listId: `${list?.id}` },
      }),
    }
  })
})
</script>

<template>
  <BaseBadges
    :badges="badges"
    clickable
    :max="max"
    :size="size"
    variant="subtle"
    :wrap="wrap"
  />
</template>
